console.group("inicializando o pack de imagens do app")



import '/var/www/apps/kpa/app/frontend/images/Polígono 4.svg';

import '/var/www/apps/kpa/app/frontend/images/UR20-1.png';

import '/var/www/apps/kpa/app/frontend/images/alimenticia.jpg';

import '/var/www/apps/kpa/app/frontend/images/alimenticia.png';

import '/var/www/apps/kpa/app/frontend/images/blueprint_background.jpg';

import '/var/www/apps/kpa/app/frontend/images/brand/app_logo_full.png';

import '/var/www/apps/kpa/app/frontend/images/brand/app_logo_vert.png';

import '/var/www/apps/kpa/app/frontend/images/brand/app_symbol.png';

import '/var/www/apps/kpa/app/frontend/images/brand/app_text.png';

import '/var/www/apps/kpa/app/frontend/images/certificacoes.jpg';

import '/var/www/apps/kpa/app/frontend/images/cliente-1.png';

import '/var/www/apps/kpa/app/frontend/images/cliente-2.png';

import '/var/www/apps/kpa/app/frontend/images/cliente-3.png';

import '/var/www/apps/kpa/app/frontend/images/cliente-4.png';

import '/var/www/apps/kpa/app/frontend/images/farmaceutica.jpg';

import '/var/www/apps/kpa/app/frontend/images/feature-1.png';

import '/var/www/apps/kpa/app/frontend/images/feature-2.png';

import '/var/www/apps/kpa/app/frontend/images/feature-3.png';

import '/var/www/apps/kpa/app/frontend/images/fios-e-cabos.jpg';

import '/var/www/apps/kpa/app/frontend/images/home-ur20.png';

import '/var/www/apps/kpa/app/frontend/images/home_bkg.jpg';

import '/var/www/apps/kpa/app/frontend/images/home_bkg_pattern.jpg';

import '/var/www/apps/kpa/app/frontend/images/home_grid_background.png';

import '/var/www/apps/kpa/app/frontend/images/home_header.jpg';

import '/var/www/apps/kpa/app/frontend/images/homem-e-cobot-kapta.png';

import '/var/www/apps/kpa/app/frontend/images/keyboard_arrows.svg';

import '/var/www/apps/kpa/app/frontend/images/light_beam.png';

import '/var/www/apps/kpa/app/frontend/images/light_beam_no_floor.png';

import '/var/www/apps/kpa/app/frontend/images/logo-kpa.png';

import '/var/www/apps/kpa/app/frontend/images/logo_white.png';

import '/var/www/apps/kpa/app/frontend/images/mask.svg';

import '/var/www/apps/kpa/app/frontend/images/missing.png';

import '/var/www/apps/kpa/app/frontend/images/motores.png';

import '/var/www/apps/kpa/app/frontend/images/motores_header.png';

import '/var/www/apps/kpa/app/frontend/images/outros_segmentos.jpg';

import '/var/www/apps/kpa/app/frontend/images/outros_segmentos.png';

import '/var/www/apps/kpa/app/frontend/images/product_empty.png';

import '/var/www/apps/kpa/app/frontend/images/product_img_template.jpg';

import '/var/www/apps/kpa/app/frontend/images/robot-3.png';

import '/var/www/apps/kpa/app/frontend/images/robot-5.png';

import '/var/www/apps/kpa/app/frontend/images/robot_asset_1.png';

import '/var/www/apps/kpa/app/frontend/images/robotica_header.jpg';

import '/var/www/apps/kpa/app/frontend/images/solucoes_header_bkg.jpg';

import '/var/www/apps/kpa/app/frontend/images/welcome_image.png';


console.groupEnd();
